/* eslint-disable no-console */
export default {
  install (Vue) {
    Vue.directive('oneClick', { // 点击后立即disabled，2.5秒后还原
      inserted (el) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true;
            el.classList.add('v-btn--disabled');
            setTimeout(() => {
              el.disabled = false;
              el.classList.remove('v-btn--disabled');
            }, 2500)
          }
        })
      }
    })

    Vue.directive('drag', { // 可拖动[欠缺参数：允许拖动的范围(通过元素ID指定)]
      inserted (el) {
        el.style.cursor = 'move';
        el.style.position = 'absolute';
        el.style.zIndex = 999999;
        let srcEl = el;
        el.onmousedown = (e) => {
          document.body.onselectstart = () => false
          let disX = e.clientX - srcEl.offsetLeft, disY = e.clientY - srcEl.offsetTop;
          let left, top;
          document.onmousemove = (e) => {
            left = e.clientX - disX;
            top = e.clientY - disY;
            srcEl.style.left = left + 'px';
            srcEl.style.top = top + 'px';
          }
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      }
    })

    Vue.directive('focus', {
      // bind: function (el) { el.focus() },
      // updated: function (el) { el.focus() },
      inserted: function (el) { el.focus() }
    })

    Vue.directive('ban-save', { // 禁止右键及保存
      inserted () {
        window.addEventListener('keydown', function (e) {
          if (e.keyCode == 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
            e.preventDefault();
          }
        })
        document.oncontextmenu = () => false;
        let frames = document.querySelector('iframe');
        if (frames) frames.onload = function () {
          this.contentWindow.document.oncontextmenu = function () { return false }
          this.contentWindow.addEventListener('keydown', function (e) {
            if (e.keyCode == 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
              e.preventDefault();
              e.stopPropagation();
            }
          }, true)
        }
      }
    })


  }
}